import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.opcionais-sales-report",
    url: "/vendas-por-opcionais",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Vendas por Opcionais",
        priority: 400,
        // authorization: (context => context.user.permissions.includes('view_closed_sales')),
        state: "app.management.opcionais-sales-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/opcionais-sales-report/index.js